import { Auth0Provider, type AppState } from '@auth0/auth0-react';
import React from 'react';
import PrototypeApp from './PrototypeApp';
import RegistryApp from './RegistryApp';
import type { RegistryConfig } from './registryConfig';

function restoreHash(appState?: AppState) {
  const returnTo = typeof appState?.returnTo === 'string' ? appState.returnTo : '';
  window.history.replaceState({}, document.title, `${window.location.pathname}${returnTo}`);
}

/** Picks the signed-in console, or the pure-mock prototype when REACT_APP_REGISTRY_MOCK=true. */
export default function RegistryRoot({ config }: { config: RegistryConfig }) {
  if (config.mockOnly) {
    return <PrototypeApp />;
  }
  return (
    <Auth0Provider
      domain={config.auth0Domain ?? ''}
      clientId={config.auth0ClientId ?? ''}
      authorizationParams={{ redirect_uri: window.location.origin, audience: config.audience }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      onRedirectCallback={restoreHash}
    >
      <RegistryApp audience={config.audience} />
    </Auth0Provider>
  );
}
